import React, { useState, useEffect } from 'react';
import BottomModal from '../ButtonGroup/BottomModal';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import { IUserLuckyOne } from '../../store/LuckyStore';
import { style } from '../../utils/image';
import './MyLuckyModal.scss';
import { checkLoadMore, ILoadMoreResult } from '../Common/ListWrapper';
import MyLucky from '../Me/MyLucky';

let luckyPage = 1;

const Index = (props: {
  onClose: () => void;
  rootStore?: RootStore;
  luckId: string | number;
}) => {
  const { onClose, rootStore, luckId } = props;
  const { wxuserStore } = rootStore!;

  const luckyRefresh = () => {
    luckyPage = 1;
    return wxuserStore.getLuckyList(luckyPage, luckId);
  };

  const luckyLoadMore = () => {
    luckyPage++;
    return wxuserStore.getLuckyList(luckyPage, luckId).then(checkLoadMore);
  };

  useEffect(() => {
    luckyRefresh();
  }, []);

  return (
    <BottomModal
      show={true}
      onHide={onClose}
      wrapClassName={'myluck-result-modal'}
      child={
        <div className="luck-myresult-modal">
          <MyLucky
            list={wxuserStore.luckyList}
            refresh={luckyRefresh}
            loadMore={luckyLoadMore}
          />
        </div>
      }
    />
  );
};

export default inject('rootStore')(observer(Index));
